module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-21 at 11.16.15 PM.d29441e9.jpeg";